import { useMemo } from 'react';

import { usePetitionActionsPageData } from '#src/app/pages/actions/pageContext';
import type {
	SupporterVoicesCommentToScriptExperiment,
	SupporterVoicesCommentToScriptExperimentVariation,
} from '#src/app/pages/actions/pageContext';

/**
 * Exposes the resolved `supporter_voices_comment_to_script` GrowthBook assignment from the page
 * data.
 *
 * There is no app-level eligibility gate here (unlike `usePsfContactDecisionMakerExperiment`):
 * logged-in/mobile targeting is owned by the GrowthBook dashboard, and petition/viewer-level
 * relevance is handled in the render tree via `useCommentToScriptArm`. This hook is a plain
 * passthrough so the arm switch (CHANGE-99079) can branch on `variation` and exposure can fire
 * off the raw `experiment`.
 */
export function useSupporterVoicesCommentToScriptExperiment(): UseSupporterVoicesCommentToScriptExperimentResult {
	const {
		data: { supporterVoicesCommentToScriptExperiment },
	} = usePetitionActionsPageData();

	return useMemo(
		() => ({
			experiment: supporterVoicesCommentToScriptExperiment,
			variation: supporterVoicesCommentToScriptExperiment.variation,
		}),
		[supporterVoicesCommentToScriptExperiment],
	);
}

type UseSupporterVoicesCommentToScriptExperimentResult = Readonly<{
	/** The raw resolved GrowthBook experiment, for exposure tracking. */
	experiment: SupporterVoicesCommentToScriptExperiment;
	variation: SupporterVoicesCommentToScriptExperimentVariation;
}>;
